
export const CDMO_OWNERSHIP_CONSTANTS = {
    TRANSFER_MODAL_TITLE: 'Transfer CDMO Ownership',
    UNCLAIM_MODAL_TITLE: 'Unclaim CDMO Profile',
    CURRENT_OWNER_SECTION: 'Current Owner Details',
    NEW_OWNER_SECTION: 'New Owner Details',
    TRANSFER_BUTTON: 'Submit',
    CANCEL_BUTTON: 'Cancel',
    UNCLAIM_BUTTON: 'Yes, Unclaim Profile',
    KEEP_BUTTON: 'No, Keep Profile',
    UNCLAIM_CONFIRMATION: 'Are you sure you want to unclaim this profile? This action cannot be undone. You will lose access to your CDMO dashboard and be converted to a standard user account.',
    DOMAIN_MISMATCH_ERROR: 'Recipient email must match the company website domain.',
    TRANSFER_SUCCESS: 'Ownership transfer initiated successfully. The recipient must accept to complete the transfer.',
    UNCLAIM_SUCCESS: 'CDMO profile unclaimed successfully.',
    TRANSFER_PENDING: 'A transfer is already pending for this CDMO.',
    FIELD_REQUIRED: 'This field is required.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    INVALID_PHONE: 'Please enter a valid phone number.',
    RECIPIENT_NAME_LABEL: 'Recipient Name *',
    RECIPIENT_PHONE_LABEL: 'Recipient Phone *',
    INITIATE_TRANSFER_FAILED: 'Failed to initiate ownership transfer. Please try again.',
    TRANSFER_NOT_FOUND: 'Transfer not found or already completed.',
};
